module.exports = __webpack_public_path__ + "static/img/manual-35.e8881cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-35.png
// module id = p7PL
// module chunks = 4